import { useEffect, useRef, useState } from "react";
// custom hook
import useSendData from "../../../hook/sendData.tsx";
import useUpdateData from "../../../hook/updateData.tsx";
import useGetData from "../../../hook/getData.tsx";
// react query
import { CreateAgent } from "../../../services/admin/user/agent/createAgent.tsx";
import { ShowAgent } from "../../../services/admin/user/agent/showAgent.tsx";
// toast
import { toast } from "react-toastify";
import { toastOptions } from "../../../features/toast/toast.tsx";
// error and form
import { useForm } from "react-hook-form";
// axios
import axios from "axios";
// router
import { useNavigate, useParams } from "react-router-dom";
import { UpdateAgent } from "../../../services/admin/user/agent/updateAgent.tsx";
// feature
import { MiladyToShamsi } from "../../../features/datePicker/miladyToShamsi.tsx";

export const CreateOrUpdate = () => {
    // form
    const { register, handleSubmit, reset }: any = useForm<any>();
    // navigate
    const { navigator }: any = useNavigate();
    // states
    const [value, setValue] = useState<any>()
    const [coord, setCoord] = useState([51.42, 35.72]);
    const [fileUpload, setFileUpload] = useState<string>();
    const [type, setType] = useState<any>('')
    const [address, setAdress] = useState<any>();
    const [latitude, setLatitude] = useState<number | any>()
    const [longitude, setLongitude] = useState<number | any>()
    const markerRef = useRef<HTMLDivElement | null>(null);
    const [images, setImages] = useState<any>([]);
    const { id } = useParams();
    const { data, isLoading, refetch } = useGetData(['plans', id], ShowAgent)
    console.log(data)
    const maxNumber = 1
    // actions
    let sendData, updateData
    const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
    };
    useEffect(() => {
        if (data) {
            let defaultFile = data.certificate;
            fetch(defaultFile)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "default.png", { type: blob.type });
                    reset({
                        certificate: file,
                    });
                });
            setFileUpload(defaultFile);
            reset({
                national_code: data.national_code,
                full_name: data.full_name,
                cellphone: data.cellphone,
                email: data.email,
                company_name: data.company_name,
                company_national_code: data.company_national_code,
            });
            setCoord([data.longitude ? data.longitude : 51.42, data.latitude ? data.latitude : 35.72])
            setAdress(data.address)
            setLatitude(data.latitude);
            setLongitude(data.longitude);
            MiladyToShamsi(data.date_of_birth.date, setValue);
            setType(data.type)
            const defaultImage = data.personal_photo;
            fetch(defaultImage)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "default.png", { type: blob.type });
                    setImages([{ data_url: defaultImage, file }]);
                });
        }
        else {
            const defaultImage = require('./../../../assets/media/icon/Ellipse 118.png');
            fetch(defaultImage)
                .then(res => res.blob())
                .then(blob => {
                    const file = new File([blob], "default.png", { type: blob.type });
                    setImages([{ data_url: defaultImage, file }]);
                });
        }
    }, [data, reset])
    const { send, pending } = useSendData(sendData, CreateAgent, navigator, '/dashboard/admin/user/agent', null, null)
    const { update, pendingUpdate } = useUpdateData(updateData, UpdateAgent, refetch, null, '/dashboard/admin/user/agent')
    const onSubmit = (data: any) => {
        // eslint-disable-next-line no-mixed-operators
        if (!value || value === null || value === '' && address === '' || address === null) {
            toast.error('تاریخ تولد و آدرس را به درستی وارد نمایید', toastOptions)
        }
        else {
            const dataToForm = new FormData();
            Object.entries(data).forEach(([key, value]: any) => {
                if (value !== undefined && value !== null) {
                    dataToForm.append(key, value);
                }
            });
            dataToForm.append('certificate', data.certificate[0]);
            dataToForm.append('address', address);
            dataToForm.append('longitude', longitude);
            dataToForm.append('latitude', latitude);
            dataToForm.append('date_of_birth', value);
            dataToForm.append('personal_photo', images[0].file);
            if (id) {
                let newData = dataToForm;
                newData.append('_method', 'PUT');
                newData.append('id', id)
                update(newData)
            }
            else {
                send(dataToForm)
            }
        }
    };
    const reverseFunction = async (map, e) => {
        let configs = {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIn0.eyJhdWQiOiIyNDM2NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIiwiaWF0IjoxNjk2MzcyNTkyLCJuYmYiOjE2OTYzNzI1OTIsImV4cCI6MTY5ODg3ODE5Miwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oEE6bnb9YLzTdsh0w_oMXY6trPg3FWm1pN1OfGfnbNAWsu3ODkyI3pfHFDfZAPJ2NHhixT7UKxeYYB-9YOmJIutiywx1CUZHdABaNv733Y1R0q-9Sx-tywHjFus5PcUgLqH4LMLMQvzduLxpVV44eJh29AKzLYBACsnUCFygxfh1zti5u7VdnKhmBMf8t6_tfSVzaUIaf0uBLeyQwJH56K7nyzHzY0wsIr3zZ8f7PXJt4vvJ74dbW05rDwVjBkXoT4EpwsCH6udlt1_nTQVER-hr8IPxs1KFHl4IG63SamYKzFROo48MMCcQT17paPgSa-P-gDeI6Amr3CvZP5_0SA'
            }
        }
        await axios.get(`https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`, configs)
            .then((response: any) => {
                setAdress(response.data.address)
                setLongitude(response.data.geom.coordinates[0])
                setLatitude(response.data.geom.coordinates[1])
            })
        if (markerRef.current) {
            markerRef.current.style.left = `${e.point.x}px`;
            markerRef.current.style.top = `${e.point.y}px`;
        }
    }
    return { isLoading, id, register, handleSubmit, coord, type, setType, maxNumber, onChange, pending, pendingUpdate, onSubmit, reverseFunction, value, setValue, markerRef, address, images, fileUpload }
}